import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export function Modules() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const modules = [{
    number: 1,
    title: 'El mundo RRHH',
    description: 'Entendé dónde podés encajar y qué roles existen.'
  }, {
    number: 2,
    title: 'Perfil profesional',
    description: 'Aprendé a comunicar tu valor en el lenguaje correcto.'
  }, {
    number: 3,
    title: 'CV + LinkedIn',
    description: 'Armá un perfil que atraiga entrevistas.'
  }, {
    number: 4,
    title: 'Búsqueda laboral',
    description: 'Dónde postularte y cómo hacerlo estratégicamente.'
  }, {
    number: 5,
    title: 'Entrevistas',
    description: 'Qué decir, cómo responder y cómo destacarte.'
  }, {
    number: 6,
    title: 'Primeros pasos en empresa',
    description: 'Cómo adaptarte y crecer en tu nuevo entorno.'
  }];
  return <section className="py-12 md:py-20 bg-slate-50" data-id="element-89">
      <div className="max-w-6xl mx-auto px-4" data-id="element-90">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-4" data-id="element-91">
          TODO LO QUE NECESITÁS PARA ENTRAR A RRHH
        </h2>
        <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-8" data-id="element-92">
          <div className="flex items-center gap-3 mb-6" data-id="element-93">
            <BookOpenIcon className="w-8 h-8 text-[#1a365d]" data-id="element-94" />
            <h3 className="text-2xl font-bold text-gray-900" data-id="element-95">
              Guía Principal: De Psicólogo a RRHH
            </h3>
          </div>
          <p className="text-gray-700 mb-8" data-id="element-96">
            El paso a paso completo para reconvertir tu perfil y acceder al
            mundo corporativo.
          </p>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-97">
            {modules.map(module => <div key={module.number} onClick={scrollToCompra} className="border border-gray-200 rounded-lg p-6 hover:border-amber-500 hover:shadow-md transition-all cursor-pointer" data-id="element-98">
                <div className="flex items-start gap-4" data-id="element-99">
                  <div className="bg-[#1a365d] text-white rounded-full w-10 h-10 flex items-center justify-center font-bold flex-shrink-0" data-id="element-100">
                    {module.number}
                  </div>
                  <div data-id="element-101">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-102">
                      Módulo {module.number} — {module.title}
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-103">
                      {module.description}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        <div className="text-center" data-id="element-104">
          <button onClick={scrollToCompra} className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-4 px-8 rounded-lg text-lg transition-all transform hover:scale-105 shadow-lg inline-flex items-center gap-2" data-id="element-105">
            QUIERO ACCEDER
          </button>
        </div>
      </div>
    </section>;
}